export default {
  state: {
    accepted: false,
  },
  mutations: {
    setDataAgreementAccepted: (state, payload) => (state.accepted = payload),
  },
};
